import axiosInstance from "../../Config/axiosConfig";
import { joinAffiliate } from './Affiliate';

export const getProfile = async () => {
  try {
    const response = await axiosInstance.get('/user/profile');
    console.log(response, 'response');
    const data = response.data.data;
    return data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const passwordUpdate = async (credentials) => {
  try {
    const response = await axiosInstance.post(
      '/user/change-password',
      credentials
    );
    const {
      data: { message, status },
    } = response;
    return { message, status };
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};


export const updateProfile = async (profileData) => {
  console.log(profileData, 'profileData');
  try {
    const response = await axiosInstance.post(
      '/user/profile/update',
      profileData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    const {
      data: { message, status, data },
    } = response;
    return { message, status, data };
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const uploadMedia = async (mediaData, config = {}) => {
  try {
    const response = await axiosInstance.post(
      '/user/profile/update/media',
      mediaData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: config.timeout ?? 180000,
      }
    );
    const {
      data: { message, status, data },
    } = response;
    return { message, status, data };
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const deactivateAccount = async () => {
  try {
    const response = await axiosInstance.get('/user/profile/deactivate');
    const {
      data: { message, status },
    } = response;
    return { message, status };
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const deleteAccount = async () => {
  try {
    const response = await axiosInstance.get('/user/profile/delete');
    const {
      data: { message, status },
    } = response;
    return { message, status };
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const applyForAffiliate = async () => {
  // Deprecated: replaced by POST /user/affiliate/join — see Services/User/Affiliate.js
  return joinAffiliate();
};

export const verifyProfile = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/user/profile/verify',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    const {
      data: { message, status },
    } = response;
    return { message, status };
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};